import { motion } from "framer-motion";
import "../styles/pages/Contact.css";

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: 0.15 * i },
  }),
};

const Contact = () => {
  return (
    <section className="contact-section">
      {/* duże plamy w tle sekcji */}
      <span className="section-blob section-blob-a" aria-hidden="true" />
      <span className="section-blob section-blob-b" aria-hidden="true" />

      <motion.div
        className="contact-inner"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* LEWA STRONA – tekst */}
        <motion.div
          className="contact-left"
          variants={cardVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          custom={0}
        >
          {/* małe blobki / kropki wokół lewej części */}
          <span className="blob blob-left" aria-hidden="true" />
          <span className="dot dot-l1" aria-hidden="true" />
          <span className="dot dot-l2" aria-hidden="true" />

          <span className="contact-badge">Kontakt & współpraca</span>

          <h1 className="contact-title">
            Pozostańmy w<br />kontakcie
          </h1>

          <p className="contact-lead">
            Masz pytania o wydarzenia soMeet, chcesz do nas dołączyć
            albo widzisz przestrzeń do współpracy? Napisz do nas – wrócimy
            z odpowiedzią tak szybko, jak to możliwe.
          </p>

          <div className="contact-coop-box">
            <h3>Jak możemy współpracować?</h3>
            <ul>
              <li>Organizujesz wydarzenia lub masz klimatyczne miejsce.</li>
              <li>
                Tworzysz markę, która chce zaistnieć w świecie.
              </li>
              <li>
                Chcesz zorganizować prywatne spotkanie lub cykl eventów
                dla swojej społeczności.
              </li>
            </ul>
            <p className="contact-coop-text">
              Opowiedz nam o swoim pomyśle – razem możemy stworzyć
              doświadczenia, które na długo zapadną w pamięci.
            </p>
          </div>

          <div className="contact-card">
            <div className="contact-row">
              <span className="contact-icon">📍</span>
              <p>
                <strong>Lokalizacja:</strong> Warszawa, Polska (jesteśmy otwarci
                na inne miasta)
              </p>
            </div>
            <div className="contact-row">
              <span className="contact-icon">📧</span>
              <p>
                <strong>Email:</strong> contact@someet.com
              </p>
            </div>
            <div className="contact-row">
              <span className="contact-icon">📱</span>
              <p>
                <strong>Instagram:</strong> @someet
              </p>
            </div>

            <div className="contact-actions">
              <a
                href="mailto:contact@someet.com"
                className="contact-btn contact-btn-primary"
              >
                Napisz do nas
              </a>
              <a
                href="https://www.instagram.com/someet_pl/"
                target="_blank"
                rel="noreferrer"
                className="contact-btn contact-btn-secondary"
              >
                Instagram
              </a>
            </div>
          </div>
        </motion.div>

        {/* PRAWA STRONA – zdjęcie */}
        <motion.div
          className="contact-right"
          variants={cardVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          custom={1}
        >
          {/* blobki / kropki po prawej */}
          <span className="blob blob-right" aria-hidden="true" />
          <span className="dot dot-r1" aria-hidden="true" />
          <span className="dot dot-r2" aria-hidden="true" />

          <motion.div
            className="contact-image-wrapper"
            whileHover={{ y: -4 }}
            transition={{ type: "spring", stiffness: 120, damping: 14 }}
          >
            <img
              src="/images/beachpeople.jpg"
              alt="Grupa znajomych przy ognisku"
              className="contact-image"
            />
            <div className="contact-image-badge">
              Spotkajmy się offline ✨
            </div>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Contact;